export default "__VITE_ASSET__Dd8JKdrl__"